/** @jsx jsx */
import { memo } from 'react';
import { jsx } from '@emotion/core';
import Button from '@atlaskit/button/standard-button';
import { actionStyle } from './internal/styles';
var SectionMessageAction = /*#__PURE__*/memo(function SectionMessageAction(_ref) {
  var text = _ref.text,
      onClick = _ref.onClick,
      href = _ref.href,
      testId = _ref.testId,
      linkComponent = _ref.linkComponent;
  return jsx("li", {
    css: actionStyle,
    "data-testid": testId
  }, onClick || href ? jsx(Button, {
    appearance: "link",
    spacing: "none",
    onClick: onClick,
    href: href,
    component: href ? linkComponent : undefined
  }, text) : text);
});
SectionMessageAction.displayName = 'SectionMessageAction';
export default SectionMessageAction;